/**
 * @flow
 * @relayHash 98898d3e43bad21aa00a16dbcceca98b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PickingSettingsQueryVariables = {||};
export type PickingSettingsQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +company: {|
      +id: string,
      +pickMethod: string,
    |},
  |}
|};
export type PickingSettingsQuery = {|
  variables: PickingSettingsQueryVariables,
  response: PickingSettingsQueryResponse,
|};
*/


/*
query PickingSettingsQuery {
  viewer {
    id
    company {
      id
      pickMethod
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "company",
        "storageKey": null,
        "args": null,
        "concreteType": "Company",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "pickMethod",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PickingSettingsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PickingSettingsQuery",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "PickingSettingsQuery",
    "id": null,
    "text": "query PickingSettingsQuery {\n  viewer {\n    id\n    company {\n      id\n      pickMethod\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9c3a6d1aff78db0ef31b108d0cec5d06';
module.exports = node;
